import {Grid, makeStyles} from '@logistics-frontend/blocks'
import {Alert} from '@logistics-frontend/blocks/legacy'
import {Buttonv2 as Button} from '@logistics-frontend/blocks/v2'
import {useI18n} from '@logistics-frontend/core/i18n'
import {AsyncStatus, useHistoryItemRequest} from '@yandex-taxi/react-integration-api'
import React, {useEffect, useState} from 'react'

type Props = {
  orderId: string
}

const useClasses = makeStyles(theme => ({
  label: {
    color: theme.palette.error.main,
  },
}))

const ReceiptButton: React.FC<Props> = ({orderId}) => {
  const t = useI18n()
  const [request, {data, status}] = useHistoryItemRequest(orderId)
  const [error, setError] = useState<string>('')
  const classes = useClasses()

  useEffect(() => {
    if (data) {
      if (data?.order?.receipt?.url_with_embedded_pdf) {
        // сделала так, потому что при первом клике по кнопке, пока не получили ответ ручки, не знаем куда реф и надо ли
        window.open(data.order.receipt.url_with_embedded_pdf, '_blank')
      }
      if (data?.order?.payment?.payment_method?.type === 'cash') {
        setError(t('order.list.receipt.cash_payment_method', 'Оплата наличными'))
      }
    }
  }, [data, t])

  return (
    <Grid alignItems="flex-end" direction="column" container>
      {error ? (
        <Alert severity="warning">{error}</Alert>
      ) : (
        <Grid item xs>
          <Button loading={status === AsyncStatus.PENDING} onClick={request} fullWidth>
            {t('order.list.receipt.button_text', 'Чек')}
          </Button>
        </Grid>
      )}
      {status === AsyncStatus.ERROR && (
        <div className={classes.label}>
          {t('order.list.receipt.not_found_error_text', 'Чек не найден. Повторите позже')}
        </div>
      )}
    </Grid>
  )
}

export default ReceiptButton
